import React from 'react';
import Layout from '../../../components/layout';
import MetaData from '../../../components/meta-data';
import Headline from '../../../components/headline';
import Breadcrumbs from '../../../components/breadcrumbs';
var PaintballIndex = function PaintballIndex(props) {
    var _props$data$seo$edges, _props$data$seo$edges2, _props$data$seo$edges3, _props$data$tbt$edges, _props$data$guns$edge;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(MetaData, {
        title: "Paintball Photos",
        description: 'Paintball photos taken throughout the years at the PSP, NPPL, NXL and many more paintball events.',
        photos: {
            full: (_props$data$seo$edges = props.data.seo.edges[0].node.full) === null || _props$data$seo$edges === void 0 ? void 0 : _props$data$seo$edges.fixed,
            facebook: (_props$data$seo$edges2 = props.data.seo.edges[0].node.facebook) === null || _props$data$seo$edges2 === void 0 ? void 0 : _props$data$seo$edges2.fixed,
            twitter: (_props$data$seo$edges3 = props.data.seo.edges[0].node.twitter) === null || _props$data$seo$edges3 === void 0 ? void 0 : _props$data$seo$edges3.fixed
        }
    }), /*#__PURE__*/ React.createElement(Breadcrumbs, {
        path: props
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "copy"
    }, /*#__PURE__*/ React.createElement("h1", null, "Paintball"), /*#__PURE__*/ React.createElement("p", null, "Paintball is by far the biggest thing outside of family and friends that I have in my life. I played for the first time when I was 12 and haven't looked back since. I've competed at the professional level since 2007 and its a forever evolving life lesson and experience that I wouldn't trade for anything. Teamwork, success, failure, taking the blame, rising to the top with a homegrown crew are just the tip of the iceberg. Here's some shots that I took throughout the years in my downtime at the tournaments for some paintball magazines (print media is still cool). The gun collection is my own private collection of guns I've acquired through the days. Sorry, NFS, I'm a hoarder \uD83D\uDE0E."))), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'left',
        image: {
            source: (_props$data$tbt$edges = props.data.tbt.edges[Math.floor(Math.random() * props.data.tbt.edges.length)].node.childImageSharp) === null || _props$data$tbt$edges === void 0 ? void 0 : _props$data$tbt$edges.fluid,
            altText: 'Dynasty Paintball Team'
        },
        link: '/photos/paintball/throw-back/',
        copy: {
            headline: {
                h1: 'Throw Back'
            },
            text: 'Some random shots I took while I was taking photos for paintball magazines and for my own online publication, Grind.'
        }
    }), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'right',
        image: {
            source: (_props$data$guns$edge = props.data.guns.edges[Math.floor(Math.random() * props.data.guns.edges.length)].node.childImageSharp) === null || _props$data$guns$edge === void 0 ? void 0 : _props$data$guns$edge.fluid,
            altText: "Drew Templeton's Paintball Guns"
        },
        link: '/photos/paintball/gun-collection/',
        copy: {
            headline: {
                h1: 'Gun Collection'
            },
            text: 'A little peek into my paintball gun collection.  SFL Autocockers, Adrenalin Angels and much more.'
        }
    }));
};
export default PaintballIndex;
var query = "1802132177";
